import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_PIPELINES } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";

const Deals = lazy(() => import("@pages/deals"));

const dealsRoutes = [
  {
    path: PATH_PIPELINES,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <Deals />,
        index: true,
      },
    ],
  },
];

export default dealsRoutes;
